import { FC } from 'react';
import './ConfigurationTabLoader.scss';

const ConfigurationTabLoader: FC = () => {
  return (
    <div className="configurationTabLoader">
      <div className="configurationHeader">
        <div className="sectionTitle animationLoader" />
        <div className="sectionDescription animationLoader" />
      </div>
      <div className="creatButtonLoader animationLoader" />
    </div>
  );
};

export default ConfigurationTabLoader;
